const validPage = (value) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? page : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return validPage(new URL(url, "https://calendar-list.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

// Paginator URLs returned by Laravel may be absolute and point at another host.
// Keep only the page token and rebuild the request against the configured Flask API.
export const localCalendarAction = (route, values = {}, query = "") => {
  const input = values || {};
  const page = validPage(input.page) || pageFromLegacyUrl(input.next_page_url);
  const parts = [];
  if (page) parts.push(`page=${page}`);
  if (query) parts.push(query);
  return `${route}${parts.length ? `?${parts.join("&")}` : ""}`;
};
